<div
  class="w-full max-w-sm rounded-2xl bg-white p-6 font-sans shadow-tfr-md">

  <!-- ── Header ── -->
  <div class="flex items-center gap-2 mb-5">
    <span class="h-2 w-2 rounded-full bg-action-blue"></span>
    <span class="text-[13px] font-medium text-slate-blue tracking-wide">Próximo Evento</span>
  </div>

  <!-- ── Event title ── -->
  <div class="mb-5">
    <p class="text-[11px] font-medium text-slate-blue uppercase tracking-wider mb-1">Reserva</p>
    <h3 class="text-[20px] font-bold leading-[1.2] text-midnight-indigo">{{ nextEvent().title }}</h3>
    <p class="text-[13px] text-slate-blue mt-1">{{ nextEvent().subtitle }}</p>
  </div>

  <!-- ── Divider ── -->
  <div class="border-t border-pale-gray mb-5"></div>

  <!-- ── Date picker ── -->
  <div class="mb-6">
    <p class="text-[11px] font-semibold text-slate-blue uppercase tracking-wider mb-3">{{ nextEvent().month }}</p>
    <div class="flex items-center justify-between gap-1">
      @for (d of days(); track d.num) {
        <div
          class="flex flex-col items-center gap-1.5 flex-1 cursor-pointer select-none">
          <span class="text-[11px] font-medium" [class.text-white]="d.active" [class.text-slate-blue]="!d.active">
            {{ d.label }}
          </span>
          <div class="h-9 w-9 rounded-full flex items-center justify-center text-[13px] font-semibold transition-colors"
            [class.bg-action-blue]="d.active"
            [class.text-white]="d.active"
            [class.text-midnight-indigo]="!d.active"
            [class.hover:bg-pale-gray]="!d.active">
            {{ d.num }}
          </div>
        </div>
      }
    </div>
  </div>

  <!-- ── Footer row ── -->
  <div class="flex items-center justify-between">
    <span class="inline-flex items-center gap-1.5 px-3 py-1 rounded-[50px] text-[12px] font-semibold
                 bg-pale-gray text-glacier-blue">
      <svg class="h-3 w-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586
             7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
        </svg>
        Confirmado
      </span>
      <span class="text-[12px] font-medium text-slate-blue">{{ nextEvent().price }} · {{ nextEvent().capacity }}</span>
    </div>

  </div>
